export enum UserMembershipPlan {
  CountyPlan = 'CountyPlan',
  Individual = 'Individual',
};

export default UserMembershipPlan;
